import {httpClient} from "@/Repositories/Reports/HttpClient";
import _ from "lodash";
import {GetIdFromObject} from "@/Repositories/helpers";

export default {

    /**
     * Creates a new Report
     *
     * @param Report
     * @returns {Promise<*>}
     */
    async storeReport(Report, ReportTypeName) {

        return httpClient.post(route('reports.store',{type:ReportTypeName}), Report);
    },


    /**
     * Fetch reports based on given criteria
     *
     * @param criteria
     * @returns {Promise<*>}
     */
    async searchReports(criteria) {
        let { page, itemsPerPage } = _.get(criteria, 'pagination');

        let filters = _.get(criteria, 'filters');

        let searchArguments = Object.assign({},
            {
                filters: filters,
                page: page,
                limit: itemsPerPage
            },
        )

        return httpClient.get(route('reports.getAll', searchArguments));
    },

    /**
     * Deletes a Report matching its identifier
     *
     * @param Report
     * @returns {Promise<*>}
     */
    async deleteReport(Report) {
        let reportId = GetIdFromObject(Report);

        return httpClient.delete(route('reports.delete', {report: reportId}));
    },

    /**
     * Updates a Report
     *
     * @param Report
     * @returns {Promise<*>}
     */
    async updateReport(Report) {
        let reportId = GetIdFromObject(Report);

        return httpClient.put(route('reports.update', {report: reportId}), Report);
    },
}
